import type { ReactNode } from "react";
import { CommandItem } from "@/components/ui/command";

interface WorkspaceSearchItemProps {
  context?: string | null;
  label: string;
  query?: string;
  onSelect: () => void;
}

function highlightMatches(text: string, query: string): ReactNode {
  if (!query.trim()) return text;
  const lower = query.toLowerCase();
  const parts: ReactNode[] = [];
  let cursor = 0;
  let idx = text.toLowerCase().indexOf(lower, cursor);

  while (idx !== -1) {
    if (idx > cursor) parts.push(text.slice(cursor, idx));
    parts.push(
      <mark key={idx} className="bg-transparent font-semibold text-[#7c3aed] dark:text-[#a78bfa]">
        {text.slice(idx, idx + query.length)}
      </mark>,
    );
    cursor = idx + query.length;
    idx = text.toLowerCase().indexOf(lower, cursor);
  }

  if (cursor < text.length) parts.push(text.slice(cursor));
  return <>{parts}</>;
}

export function WorkspaceSearchItem({
  context,
  label,
  query = "",
  onSelect,
}: WorkspaceSearchItemProps) {
  return (
    <CommandItem onSelect={onSelect} className="cursor-pointer">
      <div className="flex min-w-0 flex-col gap-0.5">
        {context ? (
          <span className="truncate text-sm leading-tight font-medium">{context}</span>
        ) : null}
        <span
          className={
            context ? "line-clamp-3 text-xs leading-snug" : "text-sm leading-tight font-medium"
          }
        >
          {highlightMatches(label, query)}
        </span>
      </div>
    </CommandItem>
  );
}
